import React, { useState } from 'react';
import { getLabel } from '../../InitData';
import PrematchContext from '../../contexts/PrematchContext';
import { getConfiguration, handleMouseOverTooltip, hideTooltip, iconSportCssClass } from '../../data/utils';
import { ReactComponent as CloseIcon } from '../../icons/menu.svg';
import { ReactComponent as PrintIcon } from '../../icons/print.svg';
import { ReactComponent as RefreshIcon } from '../../icons/refresh.svg';
import { ReactComponent as RefreshDuoIcon } from '../../icons/refresh_duo.svg';
import { ReactComponent as CollapseIcon } from '../../icons/up.svg';
import { ReactComponent as CollapseWh } from '../../icons/collapseWh.svg';
import { ReactComponent as OpenWh } from '../../icons/openWh.svg';
import { usePrematchData } from '../PrematchDataFetcher';
import FullScreenButton from './prematch-tournament-buttons/FullScreenButton';
import FavoriteTournamentToggle from './FavoriteTournamentToggle';
import WidgetFasceOrarie from './WidgetFasceOrarie';
import { systemCode } from '../..';

export default function TournamentHeader(props) {
    const conf = getConfiguration();
    const prematchData = usePrematchData();
    const prematchContext = React.useContext(PrematchContext);

    const reloadAllTournamentsEnabled = prematchContext.selectedTournaments.length <= 10;
    const tournamentData = props.tournament;
    const data = props.data;

    const [toggled, setToggled] = useState(props.toggled);

    function removeSelection() {
        prematchContext.toggleTournament(tournamentData.uniqueId);
    }

    function closeAll() {
        prematchContext.closeAllTournaments();
    }

    function handlePrint() {
        prematchContext.openPrintOdds([data]);
    }

    function handleToggle() {
        setToggled(!toggled);
    }

    function handleReload() {
        props.handleReload();
    }

    function handleReloadAll() {
        if (reloadAllTournamentsEnabled) {
            window.dispatchEvent(new CustomEvent('reload-all-tournaments'));
        }
    }

    const sport = prematchData.sportById[tournamentData.sportRef];
    const country = sport.categoryById[tournamentData.categoryRef];
    const desc = `${sport.descrizione} - ${country.descrizione} - ${tournamentData.descrizione}`;

    const icoSport = iconSportCssClass(sport.id, sport.iconClass);
    const printOddsEnabled = conf.poe;
    const eventsCount = data?.events?.length ?? null;
    
    return (
        <div className="competizione-sport" id={`competizione-${tournamentData.uniqueId}`}>
            <div className="titolo-blocco-sport bg-nero bianco pointer">
                <i className="fa fa-times margine-dx align-self-center" onClick={removeSelection}></i>
                <div className="nome-competizione-sport" onClick={() => {!conf.iwh && handleToggle()}}>
                  {conf.iwh &&
                   <FavoriteTournamentToggle
                        uniqueId={tournamentData.uniqueId}
                        onMouseOver={handleMouseOverTooltip}
                        onMouseOut={hideTooltip}
                    />
                  }                  
                    <div className={`img-fluid margine-dx ico-sport ${icoSport}`}></div>
                    <div className={`img-fluid margine-dx ico-cat ${country.categoryIcon}`}></div>
                    <span className="grassetto">{desc} {!conf.hae && eventsCount && `(${eventsCount})`}</span>
                </div>
                <div className="ricerca-titolo-blocco-sport mr-2">
                    <input type="text" placeholder={getLabel('general.search_match')} name="search" onChange={props.handleChange} onClick={(e) => { e.stopPropagation(); setToggled(true) }} autoComplete="off" />
                </div>
                <div className="icone-controllo-sport-centrale">
                    {toggled ?
                        conf.iwh ? <CollapseWh
                            className="margine-dx pointer tasto-collassa"
                            onClick={handleToggle}
                            onMouseOver={handleMouseOverTooltip}
                            onMouseOut={hideTooltip}
                            data-desc={getLabel('prematch_page.control_icon.collapse')}
                        />
                            :

                            <CollapseIcon
                                className="margine-dx pointer tasto-collassa"
                                onClick={handleToggle}
                                onMouseOver={handleMouseOverTooltip}
                                onMouseOut={hideTooltip}
                                data-desc={getLabel('prematch_page.control_icon.collapse')}
                            />
                        :
                        conf.iwh ?

                            <OpenWh
                                className="margine-dx pointer tasto-collassa ruota-180"
                                onClick={handleToggle}
                                onMouseOver={handleMouseOverTooltip}
                                onMouseOut={hideTooltip}
                                data-desc={getLabel('prematch_page.control_icon.expand')}
                            />
                            :
                            <CollapseIcon
                                className="margine-dx pointer tasto-collassa ruota-180"
                                onClick={handleToggle}
                                onMouseOver={handleMouseOverTooltip}
                                onMouseOut={hideTooltip}
                                data-desc={getLabel('prematch_page.control_icon.expand')}
                            />
                    }
                    <FullScreenButton />
                    {printOddsEnabled &&
                        <PrintIcon
                            className="margine-dx pointer"
                            onClick={handlePrint}
                            onMouseOver={handleMouseOverTooltip}
                            onMouseOut={hideTooltip}
                            data-desc={getLabel('prematch_page.control_icon.print')}
                        />
                    }
                    <RefreshIcon
                        className="margine-dx pointer reload-single"
                        onClick={handleReload}
                        onMouseOver={handleMouseOverTooltip}
                        onMouseOut={hideTooltip}
                        data-desc={getLabel('prematch_page.control_icon.reload')}
                    />
                    <FavoriteTournamentToggle
                        uniqueId={tournamentData.uniqueId}
                        onMouseOver={handleMouseOverTooltip}
                        onMouseOut={hideTooltip}
                    />
                    <RefreshDuoIcon
                        className={`margine-dx pointer reload-all ${!reloadAllTournamentsEnabled && 'opacity-2'}`}
                        onClick={handleReloadAll}
                        onMouseOver={handleMouseOverTooltip}
                        onMouseOut={hideTooltip}
                        data-desc={getLabel('prematch_page.control_icon.reload_all')}
                    />
                    <CloseIcon
                        className="pointer"
                        onClick={closeAll}
                        onMouseOver={handleMouseOverTooltip}
                        onMouseOut={hideTooltip}
                        data-desc={getLabel('prematch_page.control_icon.close_all')}
                    />
                </div>
            </div>
            {toggled && props.children}
        </div>
    );
}
